import PropTypes from "prop-types";

export default PropTypes.shape({
  radius: PropTypes.number,
  location: PropTypes.string,
  price_range: PropTypes.shape({
    min: PropTypes.number,
    max: PropTypes.number,
  }),
  bedrooms: PropTypes.shape({
    min: PropTypes.number,
    max: PropTypes.number,
  }),
  property_type: PropTypes.string,
});
